import onedeskFormulaVisitor from '@onedesk/modules/core/formula/parser/generated/onedeskFormulaVisitor'
import { InvalidFormulaType, UnknownOperatorError } from '@onedesk/modules/core/formula/parser/errors'

export class FunctionCollection {
  get(name) {
    throw new Error('needs to be implemented')
  }

  getAll() {
    throw new Error('needs to be implemented')
  }
}

export default class onedeskFormulaExecutionVisitor extends onedeskFormulaVisitor {
  constructor(functions, formulaContext = {}) {
    super()
    this.functions = functions
    this.formulaContext = formulaContext
  }

  visitRoot(ctx) {
    return ctx.expr().accept(this)
  }

  visitStringLiteral(ctx) {
    return this.processString(ctx)
  }

  visitDecimalLiteral(ctx) {
    return parseFloat(ctx.getText())
  }

  visitBooleanLiteral(ctx) {
    return ctx.TRUE() !== null
  }

  visitBrackets(ctx) {
    return ctx.expr().accept(this)
  }

  processString(ctx) {
    const literalWithoutOuterQuotes = ctx.getText().slice(1, -1)
    let literal
    if (ctx.SINGLEQ_STRING_LITERAL() !== null) {
      literal = literalWithoutOuterQuotes.replace(/\\(['\\])/g, '$1')
    } else {
      literal = literalWithoutOuterQuotes.replace(/\\(["\\])/g, '$1')
    }
    return literal
  }

  visitFunctionCall(ctx) {
    const functionName = ctx.func_name().getText().toLowerCase()
    return this.doFunc(ctx, functionName)
  }

  doFunc(ctx, functionName) {
    const functionArgumentExpressions = ctx.expr()
    let formulaFunctionType
    try {
      formulaFunctionType = this.functions.get(functionName)
    } catch (e) {
      throw new InvalidFormulaType(`Unsupported function '${functionName}'.`)
    }
    const acceptedArgs = Array.from(functionArgumentExpressions, (expr) =>
      expr.accept(this)
    )
    const argsParsed = formulaFunctionType.parseArgs(acceptedArgs)
    formulaFunctionType.validateArgs(argsParsed)
    return formulaFunctionType.execute(this.formulaContext, argsParsed)
  }

  visitBinaryOp(ctx) {
    let op

    if (ctx.PLUS()) {
      op = 'add'
    } else if (ctx.MINUS()) {
      op = 'minus'
    } else if (ctx.SLASH()) {
      op = 'divide'
    } else if (ctx.EQUAL()) {
      op = 'equal'
    } else if (ctx.BANG_EQUAL()) {
      op = 'not_equal'
    } else if (ctx.STAR()) {
      op = 'multiply'
    } else if (ctx.GT()) {
      op = 'greater_than'
    } else if (ctx.LT()) {
      op = 'less_than'
    } else if (ctx.GTE()) {
      op = 'greater_than_or_equal'
    } else if (ctx.LTE()) {
      op = 'less_than_or_equal'
    } else if (ctx.AMP_AMP()) {
      op = 'and'
    } else if (ctx.PIPE_PIPE()) {
      op = 'or'
    } else {
      throw new UnknownOperatorError(ctx.getText())
    }

    return this.doFunc(ctx, op)
  }

  visitFuncName(ctx) {
    return ctx.getText()
  }

  visitIdentifier(ctx) {
    return ctx.getText()
  }

  visitIntegerLiteral(ctx) {
    return parseInt(ctx.getText())
  }

  visitLeftWhitespaceOrComments(ctx) {
    return ctx.expr().accept(this)
  }

  visitRightWhitespaceOrComments(ctx) {
    return ctx.expr().accept(this)
  }
}
